import React, { useContext, useState, useEffect } from 'react'
import Layout from '../../product/components/templates/Layout'
import TableManage from './TableSettings/TableManage'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import * as Yup from 'yup'

const BannerImage = (props) => {
    const dynamiccontext = useContext(DynamicContext)
    const {
        propertyColumnReOrder,
        propertyColumnStatusAction,
        responseStatus: responseStatusDynamic,
    } = dynamiccontext
    const [fieldValue, setFieldValue] = useState([
        {
            label: props?.includeVideo
                ? 'Desktop Banner Image/Video *'
                : 'Desktop Banner Image *',
            type: 'uploadDropZone',
            accept: props?.includeVideo ? 'image/*,video/*' : 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: props?.includeVideo
                ? 'Add a banner image/video with aspect ratio of 16:5'
                : 'Add a banner image with aspect ratio of 16:5',
            class: 'col-sm-6 col-12',
            name: 'image',
            is_required: true,
        },
        {
            label: props?.includeVideo
                ? 'Mobile Banner Image/Video'
                : 'Mobile Banner Image',
            type: 'uploadDropZone',
            accept: props?.includeVideo ? 'image/*,video/*' : 'image/*',
            multiple: false,
            folder: 'banner',
            placeholder: props?.includeVideo
                ? 'Add a banner image/video with aspect ratio of 8:5'
                : 'Add a banner image with aspect ratio of 8:5',
            class: 'col-sm-6 col-12',
            name: 'image_mobile',
            is_required: false,
        },
        {
            label: 'Title *',
            type: 'text',
            placeholder: 'Enter the title',
            class: 'col-sm-6 col-12',
            name: 'title',
            isRequired: true,
        },
        {
            label: 'Link Path (e.g. locationmap)',
            type: 'text',
            placeholder: 'Enter the Link Path',
            class: 'col-sm-6 col-12',
            name: 'link',
            isRequired: false,
        },
    ])

    const customValidation = {
        image: Yup.string().required('Desktop Banner Image is required'),
        image_mobile: Yup.string(),
        title: Yup.string().required('Title is required'),
        // link: Yup.string().required('Link Path is required'),
    }

    const tableValues = [
        {
            field: 'updated_at',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Updated At',
        },
    ]

    return (
        <Layout>
            <TableManage
                variableName="allHomeBanner"
                tableName="home_banner"
                tableHeading="Banner Image"
                arrayValue={fieldValue}
                ignoreField={{
                    enabled: 1,
                    field: 'active',
                    value: 2,
                }}
                search_term_field={'title'}
                enableTableView={true}
                reorder={true}
                reorderTable={'home_banner'}
                propertyColumnReOrder={propertyColumnReOrder}
                sortBy={'show_order'}
                defaultAddition={true}
                tableValues={tableValues}
                customValidation={customValidation}
            ></TableManage>
        </Layout>
    )
}

export default BannerImage
